import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Utilities.types'

@Injectable({ providedIn: 'root' })
export class Utilities_grammar_format_string_array_flowService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { values: string[], delimiter?: string, finalValueDelimiter?: string }): Promise<{ formattedValue?: string }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.values)) {
      missingRequiredInParams.push('\'values\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Utilities/functions/grammar_format_string_array_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

